import { isAndroid, isMobileDevice } from "../helpers/device-info-helper";
import { SubTabsDataType } from "../layouts/header";
import { USER_ROLES } from "./constants";
import { GA_EVENTS } from "./ga-constants";
import { ALL_FEATURE_TYPES_MAP, ALL_MODULES_TYPES_MAP } from "./user-features-constants";
import { isSuperAdmin } from "../helpers/user-info-helpers";
import store from "../redux/store"; 


export const REPORTS_SUBTABS_MAP: Record<string, SubTabsDataType> = {
  sales: {
    tabId: "sales",
    text: "Sales",
    feature: ALL_FEATURE_TYPES_MAP.SALES_EXPORT,
  },
  inventory: {
    tabId: "inventory",
    text: "Inventory",
    feature: ALL_FEATURE_TYPES_MAP.INVENTORY_EXPORT,
  },
  auditLog: {
    tabId: "auditLog",
    text: "Audit Log",
    feature: ALL_FEATURE_TYPES_MAP.EXPORT_CHANGE_LOG,
  },
  syncHealthReport: {
    tabId: "syncHealthReport",
    text: "Sync Health Dashboard",
    feature: ALL_FEATURE_TYPES_MAP.SYNC_HEALTH_DASHBOARD,
  },
  custom: {
    tabId: "customReport",
    text: "Custom Reports",
    isShow: !isMobileDevice() && !isAndroid(),
    permission: [USER_ROLES.admin, USER_ROLES.manager],
    conditionsCheck: {
      licence: ["AALT"],
      role: [USER_ROLES.admin, USER_ROLES.manager],
      module: ALL_MODULES_TYPES_MAP.ADVANCED_ANALYTICS,
      feature: ALL_FEATURE_TYPES_MAP.ADVANCED_ANALYTICS,
      ga_event: GA_EVENTS.DYNAMIC_REPORT_REQUEST,
    }, //show this route in sidebar, but when opening page, show "you do not have access to this feature"
    emailIds: [],
    isNew: true,
  },
  inventoryIntegrationLogs: {
    tabId: "inventoryIntegrationLogs",
    text: "Inventory Integration Logs",
    feature: ALL_FEATURE_TYPES_MAP.MANAGE_SUPPLIERS,
    isShow: true,
    visibilityCheck(user) {
      try {
        const hasFeature =
          user?.allowedFeatures?.includes(ALL_FEATURE_TYPES_MAP.MANAGE_SUPPLIERS) ||
          user?.features?.includes(ALL_FEATURE_TYPES_MAP.MANAGE_SUPPLIERS);
        if (!hasFeature) return false;
        const { supplierAggregator } = store.getState().reportsReducer || {};
        return !!supplierAggregator && supplierAggregator.trim().length > 0;
      } 
      catch (err) {
        console.error("Visibility check for 'Inventory Integration Logs' failed — skipping tab rendering.", err);
        return false;
      }
    }
  },
}

export const SUMMARY_TYPE_FILTERS: Record<
  string,
  { id: string; label: string; type: string; }
> = {
  basic_summary: {
    id: "basic_summary",
    label: "Basic Summary",
    type: "BASIC_SUMMARY",
  },
  cost_summary: {
    id: "cost_summary",
    label: "Cost Summary",
    type: "COST_SUMMARY",
  },
  payment_summary: {
    id: "payment_summary",
    label: "Payment Summary",
    type: "PAYMENT_SUMMARY",
  },
  charge_summary: {
    id: "charge_summary",
    label: "Charge Summary",
    type: "CHARGE_SUMMARY",
  },
  tax_summary: { id: "tax_summary", label: "Tax Summary", type: "TAX_SUMMARY" },
  transaction_summary: {
    id: "transaction_summary",
    label: "Transaction Summary",
    type: "TRANSACTION_SUMMARY",
  },
  fulfilment_summary: {
    id: "fulfilment_summary",
    label: "Fulfillment Summary",
    type: "FULFILMENT_SUMMARY",
  },
  cancellation_summary: {
    id: "cancellation_summary",
    label: "Cancellation Summary",
    type: "CANCELLATION_SUMMARY",
  },
  brand_summary: {
    id: "brand_summary",
    label: "Brand Summary",
    type: "BRAND_SUMMARY",
  },
  catgory_summary: {
    id: "catgory_summary",
    label: "Category Summary",
    type: "CATGORY_SUMMARY",
  },
  channel_summary: {
    id: "channel_summary",
    label: "Channel Summary",
    type: "CHANNEL_SUMMARY",
  },
  source_summary: {
    id: "source_summary",
    label: "Source Summary",
    type: "SOURCE_SUMMARY",
  },
};

export const CRITERIA_TYPES = {
  month: "month",
  none: "none",
  day: "day",
};

export const BRANCH_SELECT_TYPES = {
  single: "SINGLE",
};

export const INVENTORY_REPORT_GROUPS = {
  item_balance: "Item Balance",
  item_activity: "Item Activity",
  inventory_activity: "Inventory Activity",
  consumption: "Consumption",
  purchase: "Purchase",
  procure: "Procure",
  credit_note: "Credit Note",
};

export const SALE_REPORT_GROUPS = {
  sale_summary: "Sale Summary",
  sale_transactions: "Sale Transactions",
  sales_items: "Sales Items",
  customer: "Customer",
  resource: "Resource",
  cash_management: "Cash Management",
  gst_reports: "GST Reports",
  others: "Others",
};
